<template>
    <!-- <li data-mobile-menu-item>
        <a href="#" data-mobile-menu-trigger>
            Translator
            <svg width="7" height="11">
                <path
                    d="M0.3,10.7L0.3,10.7c0.4,0.4,0.9,0.4,1.3,0L7,5.5L1.6,0.3C1.2-0.1,0.7,0,0.3,0.3l0,0c-0.4,0.4-0.4,1,0,1.3l4,3.9l-4,3.9 	C-0.1,9.8-0.1,10.4,0.3,10.7z"
                />
            </svg>
        </a> -->

        <div class="mobile-menu__links-panel" data-mobile-menu-panel>
            <div class="mobile-menu__panel mobile-menu__panel--hidden">
                <div class="mobile-menu__panel-header">
                    <button class="mobile-menu__panel-back" type="button">
                    <svg width="7" height="11">
                        <path
                            d="M6.7,0.3L6.7,0.3c-0.4-0.4-0.9-0.4-1.3,0L0,5.5l5.4,5.2c0.4,0.4,0.9,0.3,1.3,0l0,0c0.4-0.4,0.4-1,0-1.3l-4-3.9l4-3.9C7.1,1.2,7.1,0.6,6.7,0.3z"
                        />
                    </svg>
                    </button>
                    <div class="mobile-menu__panel-title">{{title}}</div>
                </div>
                <div class="mobile-menu__panel-body">
                    <ul class="mobile-menu__links">
                        <li data-mobile-menu-item v-for="country in countries" :key="country.code">
                            <a
                                data-mobile-menu-trigger
                                class="notranslate"
                                @click="doTranslation(country.code)" :title="country.title" >
                                {{ country.title }}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    <!-- </li> -->
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    props: {
        title: {
            type: String,
            required: true
        }
    },
    computed: {
         ...mapGetters([
            'storefrontAttributes',
            'languages'
        ]),
    },
    methods: {
        doTranslation(code) {
            window.doGTranslate(code);
            if (this.hasClickListener) {
                this.$emit('on-country-click');
            }
            return false;
        },

        /**
         * setup countries google translate lang
         */
        setupCountries() {
            const languages = this.languages.filter(item => {
                const attr_type = 'G' + item.code.toUpperCase();
                if(this.storefrontAttributes.find(attribute => attribute.type === attr_type).value == 'Y') {
                    return true;
                }
            });

            this.countries = [];
            for (const i in languages) {
                const lang = languages[i];
                this.countries.push({
                code : 'en|' + lang.code.toLowerCase(),
                title: lang.description,
                });
            }
        }
    },

    created() {
        this.setupCountries();
    }
    
}
</script>